import _toConsumableArray from "/vercel/path0/node_modules/next/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _regeneratorRuntime from "/vercel/path0/node_modules/next/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/vercel/path0/node_modules/next/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import { useCallback, useEffect, useState } from 'react';
export var useWalletValue = function useWalletValue(initialState, func) {
  var arr = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];

  var _useState = useState(initialState),
      price = _useState[0],
      setPrice = _useState[1];

  useEffect(function () {
    if (true) {
      ;

      _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return func(setPrice);

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    }
  }, _toConsumableArray(arr));
  var refetch = useCallback( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return func(setPrice);

          case 2:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  })), [func]);
  return [price, {
    refetch: refetch
  }];
};